import { Grow, Paper, TextField } from '@material-ui/core';
import DivLoader from 'components/Shared/DivLoader';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import React, { Component, Fragment } from 'react';
import rxjsOperators from 'rxjs-operators';
import { productNewService } from 'services/productNewService';

import TabWithChildren from './TabWithChildren.tsx';
import TabWithoutChildren from './TabWithoutChildren';

interface IState {
  products: IProductNew[];
  filterProducts?: string;
}

interface IProps {
  classes?: any;
}

@WithStyles(() => ({
  search: {
    width: '100%',
    '& svg': {
      width: 20,
      height: 30,
      marginRight: 10
    }
  },
  columns: {
    padding: 8,
    margin: '10px 0',
    '& p': {
      color: '#37474F',
      letterSpacing: '0.44px',
      margin: 5,
      fontWeight: 'bold'
    }
  }
}))
export default class TabContainer extends Component<IProps, IState> {
  constructor(props: {}) {
    super(props);
    this.state = { products: null };
  }

  componentDidMount() {
    productNewService
      .getProducts()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(products => this.setState({ products }));

    productNewService
      .getFilterProducts()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(filterProducts => this.setState({ filterProducts }));
  }

  findProduct = (product: IProductNew) => {
    const filterProducts = this.state.filterProducts.toLowerCase();
    const searchProduct = (product: IProductNew) =>
      String(product.id).includes(filterProducts) ||
      product.name.toLowerCase().includes(filterProducts) ||
      String(product.price).includes(filterProducts);

    if (product?.children?.length > 0) {
      return !!product.children.find(c => searchProduct(c));
    }
    return searchProduct(product);
  };

  filterProducts(event: any) {
    productNewService.setFilterProducts(event.target.value);
  }

  render() {
    const { classes } = this.props;
    const { products } = this.state;

    if (!products) {
      return (
        <Paper elevation={0} className={classes.containerPaper}>
          <DivLoader list width="100%" height="90px" />
        </Paper>
      );
    }

    const filteredProductsChats = products.filter(products => this.findProduct(products));
    const list = filteredProductsChats?.length > 0 ? filteredProductsChats : products;

    return (
      <Fragment>
        <TextField
          placeholder="Pesquisar…"
          classes={{ root: classes.search }}
          onChange={this.filterProducts}
          InputProps={{
            startAdornment: <SvgIcon name="search" />
          }}
        />

        {list.map((product, index) => (
          <div key={`content-product-${index}`}>
            {product?.children?.length > 0 ? (
              <Grow key={product.id} in={true} timeout={500 * index > 3000 ? 3000 : 500 * index}>
                <TabWithChildren key={index} product={product} isFirst={index === 0} />
              </Grow>
            ) : (
              <Grow key={product.id} in={true} timeout={500 * index > 3000 ? 3000 : 500 * index}>
                <TabWithoutChildren key={index} product={product} isFirst={index === 0} />
              </Grow>
            )}
          </div>
        ))}
      </Fragment>
    );
  }
}
